<div class="row header-section mt-5">

  <div class="col-lg-6 col-md-8 col-sm-8 col-xs-12">
    <h4>
      Wave Protocol Configuration
    </h4>
  </div>

  @if (defaults.isMersyAdminUser  || defaults.isMersyAdminSafetySystemExcellence) {
    <div class="col-lg-6 col-md-4 col-sm-4 col-xs-12 flex-right">
      <div class="OrangeButton" style="margin-right: 50px; display:flex;">
        @if (!isRemoveProtocolAssignmentEnabled) {
          <button mat-raised-button (click)="openAssignProtocolWave()"
            title="Assign Protocol to a Wave" class="btn btn-sm button-color-fix">
            Add Protocol <mat-icon class="add-button icon-color-fix">add_box</mat-icon>
          </button>
        }
        <!-- <button mat-raised-button (click)="openImportProtocols()"
        *ngIf="!isRemoveProtocolAssignmentEnabled"
        title="Import Protocols from a Wave" class="btn btn-sm button-color-fix">
        Import Protocols <mat-icon class="add-button icon-color-fix">content_copy</mat-icon>
      </button> -->
      @if (!isRemoveProtocolAssignmentEnabled) {
        <button mat-raised-button (click)="enableRemoveAssignmentMode()"
          title="Remove assigned protocols" class="btn btn-sm button-color-fix">
          Unassign <mat-icon class="add-button icon-color-fix">remove_circle</mat-icon>
        </button>
      }
      @if (isRemoveProtocolAssignmentEnabled) {
        <button mat-raised-button (click)="enableRemoveAssignmentMode()"
          title="Close unassignment mode" class="btn btn-sm button-color-fix">
          Close <mat-icon class="add-button icon-color-fix">close</mat-icon>
        </button>
      }
    </div>
  </div>
}

</div>

<div class="">
  <table mat-table #itemsList
    [dataSource]="dataSource"
    multiTemplateDataRows
    class="mat-elevation-z8 mat-table-custom" id="osh-wavesconfiguration">

    <ng-container matColumnDef="Checkbox">
      <th mat-header-cell *matHeaderCellDef>
        @if (isRemoveProtocolAssignmentEnabled) {
          <mat-checkbox class="select-all-checkbox"
            matTooltip="Select All"
            (click)="$event.stopPropagation();"
            (keydown)="$event.stopPropagation();"
            [checked]="isAllSelected()"
            [indeterminate]="isPartiallySelected()"
            (change)="controlAssignedItem($event.checked)">
            Select All
          </mat-checkbox>
        }
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="">
          @if (isRemoveProtocolAssignmentEnabled) {
            <mat-checkbox (click)="$event.stopPropagation();"
              [checked]="removeProtocolList.includes(element.protocolId)"
              (change)="controlAssignedItem($event.checked, element)"
              (keydown)="onCheckboxKeydown($event, element)">
            </mat-checkbox>
          }
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="protocolCode">
      <th mat-header-cell *matHeaderCellDef> Protocol Code </th>
      <td mat-cell *matCellDef="let element">
        <p [innerHTML]="element.protocolCode"></p>
      </td>
    </ng-container>

    <ng-container matColumnDef="protocolName">
      <th mat-header-cell *matHeaderCellDef> Protocol Name </th>
      <td mat-cell *matCellDef="let element">
        <p [innerHTML]="element.protocolName"></p>
      </td>
    </ng-container>

    <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;"
      class="item">
    </tr>
  </table>
</div>


@if (isRemoveProtocolAssignmentEnabled && defaults.isMersyAdminSafetySystemExcellence) {
  <div class="stickybottompanel">
    @if (removeProtocolList.length > 0) {
      <div class="col-lg-6" style="width:50%">
        Total selected Protocols : {{removeProtocolList.length}}
      </div>
    }
    @if (removeProtocolList.length <= 0) {
      <div class="col-lg-6" style="width:50%">
        Please select at least one Protocol
      </div>
    }
    @if (removeProtocolList.length > 0) {
      <button class="btn btn-realease btn-sm pull-right button-margin" (click)="confirmRemoveProtocols()">
        Confirm
      </button>
    }
  </div>
}

